export default {"src":"/_next/static/media/smartwatch.5f5cf4d6.svg","height":435,"width":394};